import InstructorsTable from "views/admin/tables/components/InstructorsTable";
import { useAppLanguage } from "hooks/useAppLanguage";
import { MdSchool } from "react-icons/md";

export default function InstructorsPage() {
  const isArabic = useAppLanguage() === "ar";

  return (
    <div dir={isArabic ? "rtl" : "ltr"}>
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-orange-500/10 text-orange-500 dark:bg-orange-400/10 dark:text-orange-300">
          <MdSchool className="h-6 w-6" />
        </span>
        <div>
          <h1 className="text-2xl font-extrabold text-navy-700 dark:text-white">
            {isArabic ? "إدارة المدرسين" : "Instructor management"}
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">
            {isArabic
              ? "إضافة المدرسين والمساعدين وإدارة التعيينات والصلاحيات التشغيلية."
              : "Create instructors and assistants and manage their assignments."}
          </p>
        </div>
      </div>
      <InstructorsTable />
    </div>
  );
}
